<template>
    <div>
        <!--展示-->
        <div class="Show">
            <van-nav-bar
                    :title="title"
                    left-text=""
                    left-arrow
                    @click-left="toBack()"
            />
            <div class="cmain pend_main">
                <van-collapse v-model="collapseNames">
                    <van-collapse-item title="订单筛选" value="条件" name="1">
                        <van-cell-group>
                            <van-field v-model="filter.Keywords" label="订单号" 
                                placeholder="订单号(非必填)" clearable />
                            <van-field v-model="filter.BeginDate" @click="showDatetimePicker(1)"
                                label="开始日期" placeholder="请选择开始日期" clearable />
                            <van-field v-model="filter.EndDate" @click="showDatetimePicker(2)" 
                                label="结束日期" placeholder="请选择结束日期" clearable />
                            <van-cell class="search_btn">
                                <van-button type="info" @click="search()">确定</van-button>
                            </van-cell>
                        </van-cell-group>
                    </van-collapse-item>
                </van-collapse>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="--- 没有数据了 ---"
                    @load="onLoad"
                    >
                    <van-cell-group v-for="(order, index) in list" @click="showPopup(order, index)">
                        <van-cell>
                            <span class="orderid" slot="title">{{order.id}}</span>
                            <span class="money">{{ getPriceType(order.priceType).symbol }}{{order.totalAmount}}{{ getPriceType(order.priceType).unit }}</span>
                        </van-cell>
                        <div class="products">
                            <dl v-for="item in order.items">
                                <dt>{{item.commodityName}}</dt>
                                <dd>x{{item.quantity}}</dd>
                                <div class="clearb"></div>
                            </dl>
                        </div>
                        <van-cell class="small" v-if="!order.tenantId">
                            <span slot="title">收件人</span>
                            <span>{{order.addressee && order.addressee.name}} ({{order.addressee && order.addressee.tel}})</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">订单状态</span>
                            <span>{{orderStatusTxt(order)}}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">支付状态</span>
                            <span class="paystate payunfinished" :class="{payfinished: order.payStatus==2}">{{order.payStatusDesc}}</span>
                        </van-cell>
                        <van-cell class="small" v-if="order.tenantId && order.tenantId > 0">
                            <span slot="title">取货方式</span>
                            <span>自提</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">下单时间</span>
                            <span>{{order.creationTimeFormated}}</span>
                        </van-cell>
                    </van-cell-group>
                </van-list>
                <div style="height: 60px"></div>
            </div>
            <van-popup class="pend_opera" v-model="popupIsShow" position="bottom">
                <div class="">
                    <van-cell-group>
                        <van-cell>
                            <div class="title">订单号：{{ curOrderId }}</div>
                        </van-cell>
                        <van-cell v-if="isOrderStatus && isPayFinished">
                            <van-button type="primary" @click="toPay()">立即支付</van-button>
                        </van-cell>
                        <van-cell>
                            <van-button type="warning" @click="toDetail()">订单详情</van-button>
                        </van-cell>
                        <van-cell v-if="isOrderStatus">
                            <van-button type="danger" @click="toUpdate()">修改订单</van-button>
                        </van-cell>
                        <van-cell v-if="isOrderStatus">
                            <van-button type="default" @click="toCancel()">取消订单</van-button>
                        </van-cell>
                        <van-cell>
                            <van-button type="default" @click="toClose()">关闭</van-button>
                        </van-cell>
                    </van-cell-group>
                </div>
            </van-popup>
            <div class="cmain pend_detail">
                <van-popup v-model="popupDetailIsShow" position="right">
                    <van-nav-bar
                        :title="isUpdateOrDetail === 2 ? '修改订单' : '订单详情'"
                        left-text=""
                        left-arrow
                        @click-left="popupDetailIsShow=false"
                    />
                    <van-cell-group class="detailmain">
                        <van-cell>
                            <span class="orderid" slot="title">订单号：{{orderDetail.id}}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">订单状态</span>
                            <span>{{orderStatusTxt(orderDetail)}}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">支付状态</span>
                            <span class="paystate payunfinished" :class="{payfinished: orderDetail.payStatus==2}">{{orderDetail.payStatusDesc}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">下单时间</span>
                            <span>{{orderDetail.creationTime}}</span>
                        </van-cell>
                        <div class="products">
                            <dl v-for="item in orderDetail.items">
                                <dt>{{item.commodityName}}</dt>
                                <dd>x{{item.quantity}}</dd>
                                <div class="clearb"></div>
                            </dl>
                        </div>
                        <van-cell class="small">
                            <span slot="title">订单总金额</span>
                            <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.totalAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">商品金额</span>
                            <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.productsAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small" v-if="orderDetail.freight">
                            <span slot="title">快递运费</span>
                            <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.freight}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small" v-if="orderDetail.needTakePhoto">
                            <span slot="title">标记拍照服务费</span>
                            <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.takePhotoAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small" v-if="orderDetail.serviceAmount && orderDetail.payStatus === 2">
                            <span slot="title">手续费</span>
                            <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.serviceAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small" v-if="orderDetail.cashAmount">
                            <span slot="title">余额抵扣</span>
                            <span class="">-{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.cashAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small" v-if="orderDetail.couponAmount">
                            <span slot="title">优惠卷抵扣</span>
                            <span class="">-{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.couponAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">应付金额</span>
                            <span class="money">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.paymentAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </van-cell>
                        <template v-if="!orderDetail.tenantId">
                        <div class="grouptitle">收件人
                            <van-button style="float: right; margin-top: -4px;" 
                                v-if="isUpdateOrDetail === 2"
                                type="primary" size="small" @click="openAddress"
                            >
                                选择收件人
                            </van-button>
                        </div>
                        <van-cell class="small time">
                            <span slot="title">姓名</span>
                            <span>{{orderDetail.addressee &&orderDetail.addressee.name}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">电话</span>
                            <span>{{orderDetail.addressee && orderDetail.addressee.tel}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">地址</span>
                            <span>{{orderDetail.addressee && orderDetail.addressee.detailAddress}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">身份证号</span>
                            <span>{{orderDetail.addressee && orderDetail.addressee.idCardNo}}</span>
                        </van-cell>
                        </template>
                        <van-cell class="small time" v-else>
                            <span slot="title">取货方式</span>
                            <span>自提</span>
                        </van-cell>
                        <div class="grouptitle">寄件人</div>
                        <div class="clearb"></div>
                        <van-cell class="small time">
                            <span slot="title">姓名</span>
                            <span v-if="isUpdateOrDetail === 1">{{orderDetail.consignor && orderDetail.consignor.name}}</span>
                            <template v-if="isUpdateOrDetail === 2">
                                <van-field v-model="orderDetail.consignor && orderDetail.consignor.name" placeholder="请输入寄件人姓名" />
                            </template>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">电话</span>
                            <span v-if="isUpdateOrDetail === 1">{{orderDetail.consignor && orderDetail.consignor.tel}}</span>
                            <template v-if="isUpdateOrDetail === 2">
                                <van-field v-model="orderDetail.consignor && orderDetail.consignor.tel" placeholder="请输入寄件人电话" />
                            </template>
                        </van-cell>
                        <template>
                            <div class="grouptitle">备注说明</div>
                            <div class="remark" v-if="isUpdateOrDetail === 1">
                                {{orderDetail.remark}}
                            </div>
                            <template v-if="isUpdateOrDetail === 2">
                                <van-field v-model="orderDetail.remark" type="textarea" style="min-height: 60px;" placeholder="您可以进行订单备注" />
                            </template>
                        </template>
                        <template v-if="orderDetail.parcelIds && orderDetail.parcelIds.length > 0">
                            <div class="grouptitle">运单详情</div>
                            <div v-for="exp in orderDetail.parcelIds" :key="exp" style="margin-top:10px;">
                                <expprogess :expProgressId="exp"></expprogess>
                            </div>
                            <div style="margin-bottom: 20px;"></div>
                        </template>
                        <div style="padding: 10px 15px;" v-if="isUpdateOrDetail === 2">
                            <van-button size="large" type="danger" @click="onSaveOrder">确定修改</van-button>
                        </div>
                    </van-cell-group>
                </van-popup>

                <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                    v-on:choisedReceiptor="choiseReceiptor" v-on:closeRecPopup="closeRecPopup"></cpnpeceiptor>
            </div>
        </div>
        <datetimepicker :isShowDatetimePicker="isShowDatetimePicker" 
            :dateType="dateType" :currentDate="currentDate"
            v-on:closeDatetimePicker="closeDatetimePicker"></datetimepicker>
    </div>
</template>

<script>
    import areaData from '@/js/area.js'
    import moment from 'moment'
    import { Cell, CellGroup, Collapse, CollapseItem, DatetimePicker } from 'vant';
    import cpnpeceiptor from '@/views/m/components/receiptor.vue'
    import datetimepicker from '@/views/m/components/datetimePicker.vue'
    import expprogess from '@/views/m/components/expProgress.vue'
    export default {
        name: "pendingpayment",
        components: {
            cpnpeceiptor,
            datetimepicker,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [DatetimePicker.name]: DatetimePicker,
            expprogess
        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                title: "",
                filter:{
                    Status: null,
                    BeginDate:null,
                    EndDate:null,
                    Keywords:null,
                    Page:1,
                    Size:10
                },
                popupIsShow: false,
                curIndex: null,
                curOrderId: "",
                isOrderStatus: false,
                isPayFinished: false,
                popupDetailIsShow: false,
                orderDetail: {},
                receiptorDialogVisible: false, //联系人
                isUpdateOrDetail: 1,
                updateModel: {
                    "remark": "",
                    "consignor": {
                        "name": "",
                        "tel": ""
                    },
                    "addressee": {
                        "name": "",
                        "tel": "",
                        "province": "",
                        "city": "",
                        "area": "",
                        "detail": "",
                        "idCardNo": "",
                        "idCardFrontImageUrl": "",
                        "idCardBackImageUrl": ""
                    },
                    "id": ""
                },
                isBankTo: false,  //是否银行支付截屏跳转过来的
                collapseNames: [], 
                isShowDatetimePicker: false, //显示日期选择控件
                dateType: "date",   //日期选择控件类型
                currentDate: new Date(),
                currentType: 0, //当前点击的时间是开始还是结束
                serviceAmount: 0,    // 手续费
                totalAmounts: 0 // 加了手续费的总额
            }
        },
        async mounted() {
            await areaData.getAreasData()
            let query = this.$route.query;
            if (query && query.orderId) {
                this.curOrderId = query.orderId;
                this.toDetail();
                this.isBankTo = true;
            }
            let status = this.$route.params.status;
            this.filter.Status = !isNaN(status) && status > 0 ? status : null;
            switch (parseInt(this.filter.Status)) {
                case 1:
                    this.title = "待付款";
                    break;
                case 2:
                    this.title = "待发货";
                    break;
                case 3:
                    this.title = "待收货";
                    break;
                default:
                    this.title = "所有订单";
            }
        },
        methods: {
            onLoad() {
                this.showH5Loading();
                let pars = JSON.parse(JSON.stringify(this.filter));
                if (moment(this.filter.EndDate).isValid()) {
                    pars.EndDate = moment(this.filter.EndDate).format("YYYY-MM-DD 23:59:59");
                }
                this.$axios.get(window.consts.apis.getMyOrders, {params: pars}).then(r=>{
                    this.loading = false
                    this.hideH5Loading()
                    if(r.success){
                        this.list = this.list.concat(r.result.items)
                        if(this.list.length >= r.result.totalCount){
                            this.finished = true
                        } else {
                            this.filter.Page++
                            this.finished = false
                        }
                        //this.filter.Page++
                    } else{
                        this.$dialog.alert({ message: r.error.message });
                    }
                })
            },
            showPopup(order, index) {
                this.curIndex = index;
                this.curOrderId = order.id;
                this.isOrderStatus = order.status == 1 || false;
                this.isPayFinished = order.payStatus == 0 || false;
                this.popupIsShow = true;
            },
            showDetail() {
                this.showH5Loading();
                this.$axios.get(window.consts.apis.orderDetail, {params:{id: this.curOrderId}}).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        let item = res.result;
                        this.orderDetail = res.result;
                        this.orderDetail.addressee.detailAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ") + " " + item.addressee.detail;
                        let freight = item.freight && item.freight || 0;
                        if (this.orderDetail.items && freight > 0) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "快递运费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": freight,
                                "commodityPrice": freight,
                                "quantity": 1
                            });
                        }
                        let takePhotoAmount = item.needTakePhoto && item.takePhotoAmount || 0;
                        if (this.orderDetail.items && takePhotoAmount) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "标记拍照服务费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": takePhotoAmount,
                                "commodityPrice": takePhotoAmount,
                                "quantity": 1
                            });
                        }
                        let serviceAmount = item.serviceAmount && item.serviceAmount || 0;
                        if (this.orderDetail.items && serviceAmount > 0 && item.payStatus === 2) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "手续费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": serviceAmount,
                                "commodityPrice": serviceAmount,
                                "quantity": 1
                            });
                        }
                        //this.toClose();
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        return false;
                    }
                }).catch(e => {
                    this.hideH5Loading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                });
            },
            toPay() {
                this.$router.push({ path: '/m/payment/' + this.curOrderId });
            },
            onSaveOrder() {
                //获取修改订单信息
                var valid = window.consts.validate;
                this.updateModel.id = this.orderDetail.id;
                this.updateModel.remark = this.orderDetail.remark;
                if (!this.orderDetail.consignor.name) {
                    this.$toast.fail("请输入寄件人姓名!");
                    return false;
                } else if (!this.orderDetail.consignor.tel) {
                    this.$toast.fail("寄件人手机号码格式错误!");
                    return false;
                }
                for (var i in this.updateModel.addressee) {
                    this.updateModel.addressee[i] = this.orderDetail.addressee[i];
                }
                this.updateModel.consignor = this.orderDetail.consignor;
                //提示并执行修改操作
                this.$dialog.confirm({
                    message: '确定要修改当前订单吗？'
                }).then(() => {
                    this.showH5Loading();
                    this.$axios.put(window.consts.apis.updateOrder, this.updateModel).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            let item = res.result;
                            this.$toast.success({
                                duration: 2000,
                                forbidClick: true,
                                loadingType: 'spinner',
                                message: "订单修改成功!",
                                onClose: (rt => {
                                    this.popupDetailIsShow = false;
                                    this.onLoad();
                                })
                            });
                        } else {
                            this.closeRecPopup(false);
                            this.$dialog.alert({ message: res.error.message });
                            return false;
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                        this.closeRecPopup(false);
                        this.$toast.fail("出错啦，请稍候再试!");
                        return false;
                    });
                }).catch(() => {
                    
                });
            },
            toDetail() {
                this.popupDetailIsShow = true;
                this.showDetail();
                this.isUpdateOrDetail = 1;
            },
            toUpdate() {
                this.popupDetailIsShow = true;
                this.showDetail();
                this.isUpdateOrDetail = 2;
            },
            toBack() {
                if (this.isBankTo) {
                    this.$router.replace({ path: "/m" })
                } else {
                    this.$router.back(-1)
                }
            },
            openAddress() {
                this.receiptorDialogVisible = true;
            },
            choiseReceiptor(item) {
                for (var i in this.orderDetail.addressee) {
                    this.orderDetail.addressee[i] = item.addressee[i];
                }
                this.orderDetail.addressee.detailAddress = item.addressee.fullAddress;
                this.closeRecPopup(false);
            },
            closeRecPopup(data) {
                this.receiptorDialogVisible = data;
            },
            toCancel() {
                this.$dialog.confirm({
                    message: '确定要取消订单吗？'
                }).then(() => {
                    this.showH5Loading();
                    this.$axios.post(window.consts.apis.orderCancel, {id: this.curOrderId}).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            let item = res.result;
                            this.$toast.success({
                                duration: 2000,
                                forbidClick: true,
                                loadingType: 'spinner',
                                message: "订单取消成功!",
                                onClose: (rt => {
                                    this.list.splice(this.curIndex, 1);
                                    this.toClose();
                                })
                            });
                        } else {
                            this.$dialog.alert({ message: res.error.message });
                            return false;
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                        this.$toast.fail("出错啦，请稍候再试!");
                        return false;
                    });
                }).catch(() => {
                    
                });
            },
            toClose() {
                this.popupIsShow = false;
                this.curIndex = null;
                this.curOrderId = "";
            },
            search() {
                this.filter.Page = 1;
                this.list = [];
                this.collapseNames = [];
                this.finished = true;
                this.onLoad();
            },
            showDatetimePicker(type) {
                this.currentType = type;
                this.isShowDatetimePicker = true;
            },
            closeDatetimePicker(data) {
                this.isShowDatetimePicker = false;
                if (!data || !moment(data).isValid()) {
                    return false;
                }
                data = moment(data).format("YYYY-MM-DD");
                if (this.currentType === 1) {
                    this.filter.BeginDate = data;
                } else if(this.currentType === 2) {
                    this.filter.EndDate = data;
                }
                if (moment(this.filter.BeginDate).isAfter(this.filter.EndDate)) {
                    this.filter.EndDate = null;
                    this.$toast.fail("结束日期不能小于开始日期!");
                }
            },
            convertNumber(par, reserved, symbol) {
                var reg = /^-?\d+.?\d*$/
                if (reg.test(par)) {
                    if (symbol) {
                    return par >= 0 ? parseFloat(par) : (reserved || reserved === 0 ? 0 : Number.NaN)
                    }
                    return parseFloat(par)
                }
                return reserved || reserved === 0 ? 0 : Number.NaN
            },
            // 加减法运算
            operationAddOrSub(symbol, ...values) {
                var result = 0
                var baseNum = 0
                var newValues = []
                var digits = []
                for (var i = 0; i < values.length; i++) {
                    var digit
                    try {
                    digit = values[i].toString().split('.')[1].length
                    } catch (e) {
                    digit = 0
                    }
                    digits.push(digit)
                }
                baseNum = Math.pow(10, Math.max.apply(null, digits))
                newValues = values.map(x => x * baseNum)
                try {
                    switch (symbol) {
                    case '+':
                        result = newValues.reduce((x, y) => x + y) / baseNum
                        break
                    case '-':
                        result = newValues.reduce((x, y) => x - y) / baseNum
                        break
                    }
                } catch (e) {
                    result = 0
                }
                return result
            },
            // 乘法运算
            operationMulti(...values) {
                var result = 0
                var digit = 0
                var newValues = []
                for (var i = 0; i < values.length; i++) {
                    try {
                    digit += values[i].toString().split('.')[1].length
                    } catch (e) {
                    digit += 0
                    }
                }
                newValues = values.map(x => {
                    return this.convertNumber(x.toString().replace('.', ''), 0)
                })
                result = newValues.reduce((x, y) => x * y) / Math.pow(10, digit)
                return result
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pend_main,.pend_detail {
        .van-cell-group {
            margin-top: 15px;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ccc;
        }
        .van-collapse {
            .van-cell-group {
                margin-top: 5px;
                border: 0;
                .van-field {
                    border-bottom: 1px dotted #999;
                }
            }
        }
        .small {
            padding: 5px 15px;
            .van-field {
                padding: 0 15px;
            }
        }
        .time {
            .van-cell__value {
                flex: 2;
            }
        }
        .orderid {
            font-size: 16px;
            font-weight: 700;
            color: #262626;
        }
        .money {
            font-size: 14px;
            font-weight: bold;
            color: #f21c0d;
        }
        .paystate {
            padding: 3px 8px;
            color: #fff;
        }
        .payunfinished {
            background: #ed5565;
        }
        .payfinished {
            background: #55edc3;
        }
        .products {
            margin: 0;
            padding: 10px 15px;
            background:#f5f5f5;
            dl {
                margin: 6px 0;
                padding: 0;
            }
            dt {
                margin: 0;
                padding: 0;
                float: left;
                width: 88%;
            }
            dd {
                margin: 0;
                padding: 0;
                line-height: 1.5;
                float: right;
                color: #999;
            }
        }
    }
    .pend_opera {
        .title {
            padding: 10px 0;
            font-size: 14px;
            text-align: center; 
            color: #999;
        }
        .van-cell {
            padding: 5px 15px;
        }
        .van-button {
            width: 100%;
        }
    }
    .pend_detail {
        .van-popup {
            width: 100%;
            height: 100%;
        }
        .van-nav-bar {
            position: absolute;
        }
        .detailmain {
            margin-top: 46px;
            height: calc(100% - 46px);
            overflow-y: auto;
        }
        .grouptitle {
            background:#eee;
            font-size: 16px;
            padding:10px 15px;
            color: #1ab394;
        }
        .remark {
            padding:10px 15px;
            min-height: 50px;
            line-height: 1.6;
        }
    }
    .pend_main {
        padding-top: 46px;
        .van-collapse {
            position: fixed;
            top: 46px;
            left: 0;
            width: 100%;
            z-index: 1000;
        }
        .search_btn {
            .van-button {
                width: 100%;
            }
        }
    }
    
</style>

